module.exports = __webpack_public_path__ + "media/images/orni_quiz/logo-af5b0c834716c3a08359f96627daf6ac.png";